import { useSelector } from 'react-redux'
import { selectCurrentUser } from '../userSlice'
import {
  EXTERNAL_ENTITY_TYPE,
  externalProductPestPacName,
} from '@sales-center/common'

export function useGetExternalEntityUrl(
  externalEntityId: string,
  externalEntityType: EXTERNAL_ENTITY_TYPE,
) {
  const { externalProduct, clientUrl } = useSelector(selectCurrentUser)

  switch (externalProduct) {
    case externalProductPestPacName:
      switch (externalEntityType) {
        case EXTERNAL_ENTITY_TYPE.ServiceSetups:
          return `${clientUrl}/serviceSetup/detail.asp?Mode=Edit&SetupID=${externalEntityId}`
        case EXTERNAL_ENTITY_TYPE.ServiceOrders:
          return `${clientUrl}/serviceOrder/detail.asp?OrderID=${externalEntityId}`
        case EXTERNAL_ENTITY_TYPE.Programs:
          return `${clientUrl}/program/detail.asp?Mode=Edit&ProgramID=${externalEntityId}`
      }
    default:
      return ''
  }
}
